import { AnswerPathTreeNode } from '@zinnia/form-engine-sdk';

import { NodeIds } from '../../../../nodeIds';

export const anyOtherDisorderOfTheDigestiveSystem: AnswerPathTreeNode = {
  path: 'anyOtherDisorderOfTheDigestiveSystem',
  children: [{ path: 'details', nodeId: NodeIds.healthInsuredAnyOtherDisorderOfTheDigestiveSystemDetails }],
};
